export const GET_SITE_USERS = "GET_SITE_USERS"
export const GET_SITE_USERS_SUCCESS = "GET_SITE_USERS_SUCCESS"
export const GET_SITE_USERS_FAILED = "GET_SITE_USERS_FAILED"

export const GET_USERS_BY_SEARCH = "GET_USERS_BY_SEARCH"
export const GET_USERS_BY_SEARCH_SUCCESS = "GET_USERS_BY_SEARCH_SUCCESS"
export const GET_USERS_BY_SEARCH_FAILED = "GET_USERS_BY_SEARCH_FAILED"
export const RESET_USERS_BY_SEARCH = "RESET_USERS_BY_SEARCH"
